<template>
    <div class="event-box" v-show="isShowCustomizeEvent">
        <div class="event-box-inner">
            <div class="event-box-title">Hosting/Attending an Event? Tell us about it!</div>

            <div v-if="props.customizeEventList.length > 0">
                <select class="event-select" v-model="eventSelected" @change="eventChange"
                    :style="{ 'color': eventSelected == AppConst.IntNull ? 'rgb(172, 172, 172)' : 'rgb(51, 51, 51)' }">
                    <option :value="item.ID" v-for="(item, index) in props.customizeEventList" :key="index"
                        style="color: rgb(51, 51, 51);">{{ item.EventName }}</option>
                </select>
            </div>

            <div class="event-item" v-if="isShowEventName">
                <span class="event-label">Event Name:</span>
                <textarea v-model.trim="eventName" maxlength="4000"></textarea>
            </div>

            <div class="event-item event-date">
                <span class="event-label">Event Date:</span>
                <div class="event-input">
                    <input type="text" ref="eventDateRef" v-model.trim="eventDate" @input="eventDateChange"
                        placeholder="MM/DD/YY" class="event-input-inner">
                    <div class="event-input-append">
                        <img src="https://img66.anypromo.com/frontimg/2024/Icon/icon-calendar.svg" alt="calendar"
                            width="16" height="16" @click="eventDateRef.focus">
                    </div>
                </div>
                <span style="margin-left: 5px; color: red;">{{ message }}</span>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted, ref, defineExpose } from 'vue'
import { type ICustomizeEventInfo } from '@anypromo/shared/types/SaleCustomize'
import { AppConst } from '@anypromo/shared/utils/AppConst'
import { isDate, isXXSAttack } from '@/components/utils'
import AlertDialog from '@anypromo/components-pc/AlertDialog'

const isShowCustomizeEvent = ref(false)

const eventDateRef = ref()
const eventDate = ref('')
const eventName = ref('')
const eventSelected = ref(AppConst.IntNull)
const isShowEventName = ref(true)

const message = ref('')
const customizeEventOther = 99

const props = withDefaults(defineProps<{
    customizeEventName: string,
    customizeEventDate: string,
    customizeEventList: Array<ICustomizeEventInfo>
}>(), {
    customizeEventName: '',
    customizeEventDate: '',
    customizeEventList: [] as any,
})

onMounted(() => {

    const minDate = new Date()
    minDate.setDate(minDate.getDate() + 1)

    window.$(eventDateRef.value).datepick({
        minDate: minDate,
        monthsToShow: 2,
        onClose: () => {
            eventDate.value = eventDateRef.value.value
            checkEventDate()
        }
    })

    InitPage()
})


const InitPage = async () => {
    if (props.customizeEventList.length == 0) {
        return
    }

    isShowCustomizeEvent.value = true
    isShowEventName.value = false

    if (props.customizeEventName == '' || props.customizeEventDate == '') {
        return
    }

    let customizeEventInfo = props.customizeEventList.find((value, index, arr) => {
        return value.EventName == props.customizeEventName && value.ID != AppConst.IntNull
    })

    if (customizeEventInfo) {
        eventSelected.value = customizeEventInfo.ID
        if (eventSelected.value == customizeEventOther) {
            isShowEventName.value = true
        }
    } else {
        if (props.customizeEventList.length > 0) {
            eventSelected.value = customizeEventOther
        }

        isShowEventName.value = true
    }

    eventName.value = props.customizeEventName
    eventDate.value = props.customizeEventDate
    checkEventDate()
}


const eventChange = () => {
    eventDate.value = ''
    eventName.value = ''
    message.value = ''

    if (eventSelected.value == customizeEventOther) {
        isShowEventName.value = true
    } else {
        isShowEventName.value = false
    }

    props.customizeEventList.find((value, index, arr) => {
        if (value.ID == eventSelected.value &&
            eventSelected.value != customizeEventOther &&
            eventSelected.value != AppConst.IntNull) {
            eventName.value = value.EventName
            eventDate.value = value.EventDate
            checkEventDate()
        }
    })
}

const eventDateChange = () => {
    checkEventDate()
}

const checkEventDate = () => {
    message.value = ''

    if (eventDate.value == '') {
        return
    }

    if (!isDate(eventDate.value, 'mm/dd/yyyy')) {
        message.value = "Invalid Event Date."
        return
    }

    if (new Date(eventDate.value) <= new Date()) {
        message.value = "Event Date is earlier than the current date."
        return
    }
}

const checkError = () => {
    if (eventSelected.value == customizeEventOther && eventName.value == '') {
        AlertDialog('Info', "Please input Event Name.");
        return false
    }

    if (eventName.value == '') {
        return true
    }

    if (eventName.value.length > 4000) {
        AlertDialog('Info', 'Event Name length must be less than 4000.');
        return false
    }

    if (isXXSAttack(eventName.value)) {
        AlertDialog('Info', 'Illegal Event Name.');
        return false
    }

    if (eventDate.value == '') {
        AlertDialog('Info', 'Please input Event Date.');
        return false
    }

    if (!isDate(eventDate.value, 'mm/dd/yyyy')) {
        AlertDialog('Info', 'Invalid Event Date.');
        return false
    }

    return true
}


defineExpose({
    eventName,
    eventDate,
    checkError
})

</script>

<style lang="less">
.event-box {
    padding: 0 28px 28px 28px;
    font-size: 13px;

    &-inner {
        border-top: 1px solid #ddd;
    }

    &-title {
        color: #036;
        font-size: 15px;
        font-weight: 600;
        padding: 20px 0;
    }

    select {
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        background-color: #fff;
        background-repeat: no-repeat;
        cursor: pointer;
        background-image: url(https://img66.anypromo.com/frontimg/2020/icon/arrow-down.svg);
        background-position: right 7px center;
        background-size: 15px 49px;
    }
}

.event-input {
    height: 30px;
    border: 1px solid #ddd;
    border-radius: 3px;
    font-size: 13px;
    display: flex;
    position: relative;
}

.event-input-inner {
    border: 0;
    height: 28px;
    border: 1px solid transparent;
    width: calc(100% - 56px);
}

.event-input-prepend,
.event-input-append {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.event-input-prepend:hover,
.event-input-append:hover {
    background-color: #f5f5f5;
    cursor: pointer;
}

.event-input-append {
    border-left: 1px solid #ddd;
    margin-left: auto;
}

.event-item {
    display: flex;
    margin-top: 15px;
}

.event-label {
    flex: 0 0 80px;
}

.event-item textarea {
    width: 100%;
    height: 50px;
    border: 1px solid #ddd;
    border-radius: 3px;
    resize: none;
    padding: 5px;
}

.event-dropdown-list {
    position: absolute;
    top: 28px;
    left: -1px;
    width: calc(100% - 26px);
    background-color: #fff;
    border: 1px solid #ddd;
    border-top: 0;
    border-radius: 0 0 3px 3px;
    list-style-type: none;
    padding: 5px 0;
    display: none;
}

.event-dropdown-list li {
    padding: 5px 31px;
}

.event-dropdown-list li:hover {
    background-color: #f5f5f5;
}

.event-date .event-input-inner {
    border-radius: 3px;
    padding: 0 5px;
    width: calc(100% - 28px);
}

.event-date {
    align-items: center;
}

.event-date .event-input {
    width: 110px;
}

.event-select {
    border-radius: 3px;
    width: 100%;
    height: 35px;
    padding: 0 10px;
    border: 1px solid #ddd;
}
</style>